import { ChangeDetectionStrategy, Component } from "@angular/core";
import { IAlertComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { OverlayRule } from "@m19-board/overlay/overlay-service/overlay-rules";
import { OnboardingCtaComponent } from "@m19-board/containers/board-layout/board-sidebar/onboarding-cta.component";

@Component({
  selector: "app-marketplace-not-included-overlay",
  imports: [TranslocoDirective, IAlertComponent, OnboardingCtaComponent],
  template: `<div class="m-8">
    <IAlert *transloco="let t">
      <span>{{ t("overlays.marketplace_not_included") }}</span>
      <app-onboarding-cta class="w-40"></app-onboarding-cta>
    </IAlert>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketplaceNotIncludedOverlayComponent {
  static readonly rule = OverlayRule.MARKETPLACE_NOT_INCLUDED;
}
